import { environment } from "../../../../environments/environment";

// The attachment's own blob SAS url hands back whatever content type the consultant
// app stamped on its upload, under a file name that is a bare guid. This endpoint
// resolves both from the file's first bytes, so it is the only url a receipt can be
// downloaded from and still open.
export const getReceiptUri = (previewUri: string) =>
  `${environment.timereportServiceUrl}/api/internal/v1/timereports${previewUri}`;

export const getReceiptPreviewUri = (previewUri: string) =>
  `/img-viewer?link=${getReceiptUri(previewUri)}`;
